export const errorMessages = {
  required: 'This is a required field',
  email: 'Invalid email format',
  invalidPassword:
    'Password must contain at least 6 characters, one uppercase (A-Z), ' +
    'one digit (0-9) and a non-alphanumeric character (!, $, #,%)',
  invalidCnamLength: 'Caller ID exceeded length limit, max length is 15 symbols',
  invalidCnamBadEncoding: 'Bad Encoding',
  invalidCnamSpecialCharacters:
    'Make sure Caller ID do not begin with a space or an asterik(*) ' +
    'and does not contain any invalid special characters',
  invalidCnamAlphaCharacters: 'Caller ID must contain at least one alpha character',
  invalidIpAddress: 'Invalid IP address format',
  invalidUrlAddress: 'Invalid URL address format',
  uniqueBy: 'Duplicate',
  invalidPhoneNumber: 'Invalid phone number',
  invalidNumber: 'Invalid number',
  invalidTimezone: 'Invalid timezone',
  mtxDatetimepickerParse: 'Invalid time format',
  matDatetimePickerParse: 'Invalid time format',
  greaterThenStart: 'Must be greater than start date',
  timeFormat: 'Invalid time format, must be in HH:mm format',
};
